import { render } from "./Allergeni.vue?vue&type=template&id=f716760e&scoped=true"
import script from "./Allergeni.vue?vue&type=script&lang=js"
export * from "./Allergeni.vue?vue&type=script&lang=js"

import "./Allergeni.vue?vue&type=style&index=0&id=f716760e&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f716760e"]])

export default __exports__